<div class="dn-dialog-icon">
    <img [src]="icon"
         *ngIf="icon && state.showIcon"
         style="height: 30px; width: 30px;" />
</div>

<div class="message"
     [ngClass]="{'no-icon': !state.showIcon}"
     [innerHtml]="state.message">
</div>

<div class="dn-dialog-buttons">
    <div class="dn-button dn-button-red"
         (click)="onConfirm()">{{state.okText || '确定'}}</div>
    <div class="buttons-gap"></div>
    <div class="dn-button"
         (click)="onCancel()">{{state.cancelText || '取消'}}</div>
</div>
